import { type ReactNode, useId } from "react";

/**
 * A status column (section 11.0): an uppercase title with a count, then its
 * cards. On a wide screen the column has the row's height and scrolls on its
 * own when its cards overflow (section 11.1).
 */
export function StatusColumn({
  title,
  count,
  empty,
  children,
  columnId,
}: {
  title: string;
  count: number;
  empty: string;
  children: ReactNode;
  /** Which column it is, for what lines up with it (the open-tickets tray covers Closed). */
  columnId?: string;
}) {
  const headingId = useId();
  return (
    <section
      aria-labelledby={headingId}
      data-column={columnId}
      className="flex min-w-0 flex-1 flex-col gap-2.5 rounded-panel border border-line bg-panel-2 p-4"
    >
      <div className="flex items-center gap-2">
        <h3 id={headingId} className="text-[12.5px] font-[650] tracking-[0.08em] text-muted uppercase">
          {title}
        </h3>
        <span className="inline-flex h-[22px] min-w-[22px] items-center justify-center rounded-pill border border-line px-1.5 font-mono text-[11.5px]">
          {count}
        </span>
      </div>
      {count === 0 ? (
        <p className="text-[13px] text-muted">{empty}</p>
      ) : (
        <ul className="flex flex-col gap-2.5">{children}</ul>
      )}
    </section>
  );
}
